import DocumentModel from '../models/DocumentModel';

export default Backbone.Collection.extend({
    model: DocumentModel
});
